import { useParams } from "react-router-dom";
import { ComunidadNewsFeed } from "@/hooks/api/comunidad";
import { NewsArchiveTab } from "../psychologist/tabs";

const SLUG_TO_FEED: Record<string, ComunidadNewsFeed> = {
  "psi-platform": "psi_platform",
  institucional: "institutional",
};

export const NewsArchivePage = () => {
  const { feedSlug } = useParams<{ feedSlug: string }>();
  const feed = SLUG_TO_FEED[feedSlug ?? ""] ?? "psi_platform";
  return <NewsArchiveTab feed={feed} />;
};
